import type { PriceDistributionBucket, SessionAnalytics } from '@/types/session';

/** What the heatmap's Time Spent % column shows; `hidden` drops the column entirely. */
export type TimeSpentColumn =
  | { kind: 'hidden' }
  | { kind: 'loading' }
  | { kind: 'unavailable' }
  | { kind: 'ready'; buckets: PriceDistributionBucket[] };

/** One row's cell: a percentage, or the column-wide loading/unavailable state. */
export type TimeSpentCellValue = number | 'loading' | 'unavailable';

interface TimeSpentColumnInput {
  enabled: boolean;
  analytics: SessionAnalytics | null;
  error: string | null;
}

/**
 * Keeps the column in place while session analytics load so the table never shifts:
 * skeleton until the request settles, then bars or an unavailable dash.
 */
export function getTimeSpentColumn({
  enabled,
  analytics,
  error,
}: TimeSpentColumnInput): TimeSpentColumn {
  if (!enabled) {
    return { kind: 'hidden' };
  }
  if (analytics == null) {
    return error == null ? { kind: 'loading' } : { kind: 'unavailable' };
  }
  return analytics.dataAvailability.priceDistribution.status === 'available'
    ? { kind: 'ready', buckets: analytics.priceDistribution }
    : { kind: 'unavailable' };
}
